(function () {
  const panel = document.getElementById('CollectionFacets');
  const backdrop = document.querySelector('[data-facets-close].facets-backdrop');
  const openBtn = document.querySelector('[data-facets-open]');
  const closeTriggers = document.querySelectorAll('[data-facets-close]');

  if (!panel || !openBtn) return;

  function openFacets() {
    panel.classList.add('is-open');
    panel.classList.remove('hidden-mobile');
    backdrop?.removeAttribute('hidden');
    backdrop?.classList.add('is-visible');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFacets() {
    panel.classList.remove('is-open');
    if (window.matchMedia('(max-width: 1023px)').matches) {
      panel.classList.add('hidden-mobile');
    }
    backdrop?.classList.remove('is-visible');
    backdrop?.setAttribute('hidden', '');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', () => {
    if (panel.classList.contains('is-open')) {
      closeFacets();
    } else {
      openFacets();
    }
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', closeFacets);
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      panel.classList.remove('is-open', 'hidden-mobile');
      backdrop?.classList.remove('is-visible');
      backdrop?.setAttribute('hidden', '');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
})();
